import React from 'react';
import styled from 'styled-components';

interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const FormInput = ({
  ...rest // 👈 other props like name, value, onChange, etc.
}: FormInputProps) => {
  return (
    <Input>
      <input 
        {...rest}
      />
    </Input>
  );
};

export default FormInput;

const Input = styled.div`
  display: flex;
  padding: 0.5rem 0rem;
  
  input {
    width: 100%;
    font-family: 'Poppins-Medium';
    font-size: 0.8rem;
    padding: 0.6rem 0.8rem;
    border-radius: 6px;
    appearance: none;
    outline: none;
    border: 1px solid #ccc;
  }
`;
